import { render, staticRenderFns } from "./view-settings-dialog-new.vue?vue&type=template&id=326fcdee&"
import script from "./view-settings-dialog-new.vue?vue&type=script&lang=js&"
export * from "./view-settings-dialog-new.vue?vue&type=script&lang=js&"
import style0 from "./view-settings-dialog-new.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardText,VCheckbox,VIcon})
